module.exports = ["ამ წამს","%s წამის წინ","%s წუთის წინ","%s საათის წინ","%s დღის წინ","%s კვირის წინ","%s თვის წინ","%s წლის წინ"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/ka-GE.json
// module id = K9vJ
// module chunks = 1